<template>
  <LayoutGeneral
    v-if="!areCookiesEnabled"
    :show-close-button="false"
    @close="close"
    class="c-modal--notification">

    <template slot="header">
    </template>

    <template slot="body">
      <div>
        <i class="c-icon c-icon--cookie"></i>
        <h4 class="c-modal--notification__title">{{ $t('cookie.disabled') }}</h4>

        <p class="c-modal--notification__description">{{ $t('cookie.enable') }}</p>
      </div>
    </template>
  </LayoutGeneral>
</template>

<script>
import LayoutGeneral from '@/shared/components/modal/GeneralLayout';

export default {
  computed: {
    areCookiesEnabled() {
      return navigator.cookieEnabled;
    },
  },
  methods: {
    close() {},
  },
  components: {
    LayoutGeneral,
  },
};
</script>



// WEBPACK FOOTER //
// NoCookiesModal.vue?53509e48